import type { ButtonProps } from 'framework/ui/mui-builder';
import { Button, Tooltip } from 'framework/ui/mui-builder';
import { ActionIconButton } from 'framework/ui/ui-builder';
import type { ViewTypeAction } from '../contracts/viewTypes';

interface ViewTypeActionButtonProps {
  action: ViewTypeAction;
  defaultTextVariant: ButtonProps['variant'];
}

const getTextButtonColor = (color: ViewTypeAction['color']): BasicColors | undefined =>
  color === 'default' || color === 'inherit' ? 'neutral' : (color as BasicColors | undefined);

const ViewTypeActionButton = ({ action, defaultTextVariant }: ViewTypeActionButtonProps) => {
  if (action.icon) {
    return (
      <ActionIconButton
        label={action.label}
        icon={action.icon}
        tooltip={action.tooltip}
        color={action.color}
        variant={action.variant}
        disabled={action.disabled}
        onClick={action.onClick}
      />
    );
  }

  const button = (
    <Button
      size="small"
      variant={action.variant ?? defaultTextVariant}
      color={getTextButtonColor(action.color)}
      onClick={action.onClick}
      disabled={action.disabled}
    >
      {action.label}
    </Button>
  );

  return action.tooltip ? (
    <Tooltip title={action.tooltip}>
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export default ViewTypeActionButton;
